function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTalentNetworkIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M517.931 395.227a10.305 10.305 0 0 1-8.353 2.376 11.258 11.258 0 0 0-1.195-3.1 7.62 7.62 0 0 0 8.2-1.691 1.322 1.322 0 0 1 1.865 0l.017.017a1.322 1.322 0 0 1 0 1.865l-.464.464a1.077 1.077 0 0 1-.07.065",
    transform: "translate(-499.201 -388.08)",
    style: {
      fill: "currentColor",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.88 517.929a10.306 10.306 0 0 1-2.376-8.353 11.258 11.258 0 0 0 3.1-1.195 7.62 7.62 0 0 0 1.691 8.2 1.322 1.322 0 0 1 0 1.865l-.017.017a1.321 1.321 0 0 1-1.865 0l-.464-.464a1.097 1.097 0 0 1-.065-.07",
    transform: "translate(-618.027 -499.198)",
    style: {
      fill: "currentColor",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.348 634.881a10.307 10.307 0 0 1 8.352-2.381 11.255 11.255 0 0 0 1.194 3.1 7.621 7.621 0 0 0-8.2 1.691 1.321 1.321 0 0 1-1.865 0l-.017-.017a1.321 1.321 0 0 1 0-1.865l.464-.464a.868.868 0 0 1 .07-.065",
    transform: "translate(-388.078 -618.028)",
    style: {
      fill: "currentColor",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.226 393.349a10.306 10.306 0 0 1 2.374 8.351 11.252 11.252 0 0 0-3.1 1.195 7.62 7.62 0 0 0-1.69-8.2 1.321 1.321 0 0 1 0-1.865l.017-.017a1.321 1.321 0 0 1 1.865 0l.464.464a.868.868 0 0 1 .065.07",
    transform: "translate(-388.079 -388.079)",
    style: {
      fill: "currentColor",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.082 288a2.3 2.3 0 1 0 2.3 2.3 2.3 2.3 0 0 0-2.3-2.3",
    transform: "translate(-511.082 -288)",
    style: {
      fill: "currentColor",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.082 753.562a2.3 2.3 0 1 0 2.3 2.3 2.3 2.3 0 0 0-2.3-2.3",
    transform: "translate(-511.082 -734.164)",
    style: {
      fill: "currentColor",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M755.863 520.781a2.3 2.3 0 1 0 2.3 2.3 2.3 2.3 0 0 0-2.3-2.3",
    transform: "translate(-734.164 -511.082)",
    style: {
      fill: "currentColor",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.3 520.781a2.3 2.3 0 1 0 2.3 2.3 2.3 2.3 0 0 0-2.3-2.3",
    transform: "translate(-288 -511.082)",
    style: {
      fill: "currentColor",
      fillRule: "evenodd"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalentNetworkIcon);
export default __webpack_public_path__ + "static/media/talent-network-icon.bb14bb42.svg";
export { ForwardRef as ReactComponent };